var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_vm._m(0),_c('section',[_c('veui-schedule',{attrs:{"hour-class":_vm.hourClass,"shortcuts":_vm.shortcuts,"shortcuts-display":"popup"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('code',[_vm._v("<veui-schedule>")])])
}]

export { render, staticRenderFns }